import {API_URL, apiPost} from '../api'

export type TypeSlot = 'leaderboard-banner' | 'tradermap-card' | 'announce-event' | 'landing-event' | 'popup-event'

interface IProps {
    name: string
    status: string
    start_at: string
    end_at: string
    priority: number
    language: string
    pc_url?: string
    mo_url?: string
}
export const createPromotion = async (data: IProps) => {
    return await apiPost(API_URL, 'admin/promotion', data)
}
